import React from "react";
import {
  bannerSubTitleLabel,
  bannerTitleLabel,
} from "../constants/translations";
import "./componentsStyle.scss";
import { PrimaryButton } from "./PrimaryButton";
import { scrollToSection } from "../hooks/ScrollToSection";

export const Banner = ({ languageId }) => {
  return (
    <div className="banner">
      {/* <img src={BannerImg} alt="Banner" class="banner-img" /> */}
      <div className="banner-content">
        <div className="title">
          {bannerTitleLabel.find((label) => label.id === languageId)?.label}
        </div>
        <div className="subTitle">
          {bannerSubTitleLabel.find((label) => label.id === languageId)?.label}
        </div>
        <div className="actions">
          <PrimaryButton
            label="Book Now"
            type="primary"
            onClick={() => scrollToSection("packages")}
          />
          {/* <PrimaryButton label="learn more" type="text" /> */}
        </div>
      </div>
    </div>
  );
};
